
<template>
  <div class="guide-order-detail page-bg">
    <div class="content">
      <div>
        <div class="order-title font-scme">
          派单名称派单名称派单名称派单名称派单名称派单名称派单称派单派单名称...
        </div>
        <div class="price-box flex-row">
          <span> 导服费用: </span>
          <span class="flex1" style="color: #ff3333"> ￥300.00 </span>
          <span> 待接团</span>
        </div>
      </div>
      <div>
        <div class="text">订单编号：342873463827463287</div>
        <div class="text">接团时间：2021年4月18日</div>
        <div class="text">送团时间：2021年4月23日</div>
        <div class="text">成团人数：50人</div>
        <div class="text">接团城市：江西南昌</div>
        <div class="text">接团方式：大巴</div>
        <div class="text">送团方式：自由</div>
      </div>
      <div>
        <div class="step-title font-scme">旅行社信息</div>
        <div class="html-box">
          我国《旅行社管理条例》中指出：旅行社是指以营利为目的，从事旅游业务的企业。
          其中旅游业务是指为旅游者代办出境、入境和签证手续，招徕、接待旅游者，为旅游者安排食宿等有偿服务的经营活动。
        </div>
      </div>
      <div>
        <div class="step-title font-scme">行程信息</div>
        <div class="html-box">
          我国《旅行社管理条例》中指出：旅行社是指以营利为目的，从事旅游业务的企业。
          其中旅游业务是指为旅游者代办出境、入境和签证手续，招徕、接待旅游者，为旅游者安排食宿等有偿服务的经营活动。
        </div>
      </div>
      <div>
        <div class="step-title font-scme">游客信息</div>
        <div class="html-box">
          我国《旅行社管理条例》中指出：旅行社是指以营利为目的，从事旅游业务的企业。
          其中旅游业务是指为旅游者代办出境、入境和签证手续，招徕、接待旅游者，为旅游者安排食宿等有偿服务的经营活动。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.guide-order-detail {
  height: 100%;
  box-sizing: border-box;
  color: #333;
  .content {
    box-sizing: border-box;
    padding: 16px;
    > div {
      padding: 16px;
      background-color: white;
      margin-bottom: 16px;
      border-radius: 5px;
    }
    .order-title {
      font-size: 18px;
      line-height: 22px;
    }
    .price-box {
      margin-top: 10px;
      font-size: 15px;
      color: #666;
    }
    .text {
      font-size: 14px;
      color: #666;
      padding: 4px 0;
    }
    .step-title {
      font-size: 15px;
    }
    .html-box {
      font-size: 14px;
      color: #666;
      line-height: 18px;
      margin-top: 12px;
    }
    overflow-y: scroll;
    height: 100%;
  }
}
</style>